<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right"></div>
                    <h4 class="page-title">Trainee Followup File Update</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <div class="alert alert-danger alert-dismissible fade show"
                         role="alert" v-show="show">
                            <span :key="index" v-for="(err, index) in validation_errors">
                              {{ err[0] }} <br/>
                            </span>
                    </div>

                    <form action="" enctype="multipart/form-data" files="true" role="form">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <label for="caption">Caption <span class="c-required">*</span></label>
                                <input type="text" v-model="caption" v-validate="'required'" id="caption" name="caption" placeholder="Enter caption"  class="form-control form-control-sm" />
                                <div class="invalid-feedback">
                                    Please enter caption.
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <label for="file">File</label>
                                <input  type="file" id="file" name="file" ref="file"
                                        @change="getFile()" accept=".jpg,.jpeg,.png"  class="form-control form-control-sm"/>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-6 col-sm-6">
                                <label for="remarks">Remarks <span class="c-required">*</span></label>
                                <input type="text" v-model="remarks" v-validate="'required'" id="remarks" name="remarks" placeholder="Enter remarks"
                                       class="form-control form-control-sm" />
                                <div class="invalid-feedback">
                                    Please enter remarks.
                                </div>
                            </div>
                        </div>

                        <button class="btn btn-success btn-sm mt-3 mr-2" @click.prevent="update">Update</button>
                    </form>
                </b-card>
            </div>
        </div>

    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Trainee Followup File",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Trainee Followup File",
                items: [
                    {
                        text: "Dashboard",
                        active: true
                    },
                    {
                        text: "Trainee",
                        href: ""
                    }
                ],
                trainee_id: "",
                fileLengthExceeds: false,
                file: "",
                caption: "",
                remarks: "",
                validation_errors: {},
                show: false,
            };
        },


        mounted() {
            this.followup_doc_id = this.$route.params.followup_doc_id;
            this.getFollowupDoc();
        },
        methods: {
            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let formData = new FormData();
                        formData.append("file", this.file);
                        formData.append("caption", this.caption);
                        formData.append("remarks", this.remarks);

                        http.post("api/trainee/followup-doc/update/" + this.followup_doc_id, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "Content-type": "application/json"
                                }
                            })
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    // this.resetForm();
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },

            getFile() {
                this.file = this.$refs.file.files[0];
                if (this.file.size > 3072000) {
                    this.$bvToast.toast("File size not greater then 3 MB", {
                        title: "Error",
                        autoHideDelay: 5000,
                        variant: "error"
                    });
                    this.file = "";
                }
            },

            resetForm() {
                this.$validator.reset();
                this.$refs.file.value = "";
                this.remarks = "";
                this.caption = "";
            },

            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },

            async getFollowupDoc() {
                await http.get("api/trainee/followup-doc/edit/" + this.followup_doc_id)
                    .then(resource => {
                        this.caption = resource.data.file.caption;
                        this.remarks = resource.data.file.remarks;
                })
                .catch()
            }
        },
    };
</script>
<style>
    .c-required {
        color: red;
    }
</style>
